import _ from 'lodash'

export default {
	name : 'textarea-field',
	props : ['data'],
	data () {
		return {
			field : {
				value : this.data.value
			}
		}
	},
	methods : {
		changeData (event) {

			this.$emit('changeData', event.target.value)

		}
	}
}


// WEBPACK FOOTER //
// ./src/components/general/fields/textarea/script.js